export const getAvatarClass = (firstName, lastName) => {
  const input = firstName.concat(lastName).split('');
  let output = '';

  input.forEach(i => {
    output += i.charCodeAt(0).toString(2);
  });

  const match = output.match(/1/g);
  const res = ((match && match.length) || 1) % 9;

  if (res <= 0 || res > 7) return 'avatar-7';

  return `avatar-${res}`;
};

export const cutStringInChunks = (string, chunkLength) => {
  const numChunks = Math.ceil(string.length / chunkLength);
  const chunks = new Array(numChunks);

  for (let i = 0, o = 0; i < numChunks; ++i, o += chunkLength) {
    chunks[i] = string.substr(o, chunkLength);
  }

  return chunks;
};

export const processErrors = errorsArr => errorsArr.map(err => {
  if (!err.attribute && !err.parameter) return err;
  let msg = err.message.replace('{attribute}', err.attribute);

  if (Object.keys(err.parameter).length) {
    Object.keys(err.parameter).forEach(key => {
      msg = msg.replace(`{${key}}`, err.parameter[key]);
    });
  }

  return msg.charAt(0).toUpperCase() + msg.slice(1);
});

const getAvatarPath = url => url.substring(url.indexOf('public'));

export const avatarUrlWithResize = (imageUrl, size = '30x30') => {
  const beggining = imageUrl.substring(0, imageUrl.indexOf('static') + 6);

  return (imageUrl && imageUrl.trim() ? `${beggining}/${size}/${getAvatarPath(imageUrl)}` : '');
};

const merge = (left, right, field) => {
  const result = [];

  while (left.length && right.length) {
    if (right[0][field] <= left[0][field]) {
      result.push(left.shift());
    } else {
      result.push(right.shift());
    }
  }

  while (left.length) { result.push(left.shift()); }

  while (right.length) { result.push(right.shift()); }

  return result;
};

export const mergeSort = (arr, field) => {
  if (arr.length < 2) { return arr; }

  const middle = parseInt(arr.length / 2, 10);
  const left = arr.slice(0, middle);
  const right = arr.slice(middle, arr.length);

  return merge(mergeSort(left, field), mergeSort(right, field), field);
};
